import {SparseField} from '../types'

export const prop: SparseField<string, true> = {
  api: {
    contribute: ({field, value, utils: {all, propParam}}) =>
      all(propParam(field, value)),
  },
}
